<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 col-6">
            <input type="text" [(ngModel)]="filterKeyword" [placeholder]="'SEARCH' | translate" class="form-control" (ngModelChange)="getList()" />
          </div>
          <div class="col-md-3 col-6">
            <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
              <select [(ngModel)]="filterMonth" id="monthYear" class="form-control pr-3 text-capitalize" (ngModelChange)="getList()">
                <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                <option *ngFor="let month of months" [value]="month" [label]="getMonthName(month)">{{ month }}</option>
              </select>
            </label>
            <label for="years" class="mb-0 mx-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
              <select id="years" [(ngModel)]="filterYear" class="form-control pr-3" (ngModelChange)="getList()">
                <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                <option *ngFor="let year of years">{{ year }}</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </section>
    <section class="card">
      <div class="card-header row border-bottom">
        <div class="col-md-3 col-12 font-weight-bold">{{ "COMPLETE_NAME" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "ORDINARY_SALARY" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "REFUND" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "SALARY_MONTH_12" | translate }}</div>
        <div class="col-md-2 col-12 font-weight-bold">{{ "TOTAL_MONTH" | translate }}</div>
        <div class="col-md-1 col-12"></div>
      </div>
      <div class="card-body px-0" *ngIf="costsList && costsList.length > 0">
        <div class="border-bottom" *ngFor="let record of costsList; let i = index">
          <div class="d-flex align-items-center py-1" [ngClass]="showRecord === i ? 'bg-light' : ''">
            <div class="col-md-3 col-12">
              <a [routerLink]="'user/profile/' + record.hash">{{ record.complete_name }}</a>
            </div>
            <div class="col-md-2 col-12">{{ _utilsService.addDotsToNumber(record.ordinary_salary) }}&euro;</div>
            <div class="col-md-2 col-12">{{ _utilsService.addDotsToNumber(record.extra_contributions + record.extra_salary) }}&euro;</div>
            <div class="col-md-2 col-12">{{ _utilsService.addDotsToNumber(record.net_salary) }}&euro;</div>
            <div class="col-md-2 col-12">{{ _utilsService.addDotsToNumber(record.total_cost) }}&euro;</div>
            <div class="col-md-1 col-12 text-right">
              <button class="btn text-primary" *ngIf="showRecord !== i" type="button" (click)="showRecord = i">
                <span [data-feather]="'plus-circle'" [size]="22"></span>
              </button>
              <button class="btn text-primary" *ngIf="showRecord == i" type="button" (click)="showRecord = -1">
                <span [data-feather]="'minus-circle'" [size]="23"></span>
              </button>
            </div>
          </div>
          <div class="px-2 py-1" [ngClass]="showRecord === i ? '' : 'd-none'">
            <h3>{{ "DETAIL_EMPLOYEE_COSTS" | translate }}</h3>
            <div class="row mt-075">
              <div class="col-md-3 pb-1">
                <strong>{{ "REWARDS" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.reward) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "CONTRIBUTIONS" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.contributions) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "TICKET_VALUE" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.ticket_value) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "HEALTH_CARE" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.health_care) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "TRANSFERS" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.transfers) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "REFUNDS" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.refunds) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "EXTRA_CONTRIBUTIONS" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.extra_contributions) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "EXTRA_SALARY" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.extra_salary) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "TFR_SLICE" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.tfr_slice) }}&euro;
              </div>
              <div class="col-md-3 pb-1"><strong>INAIL</strong>: {{ _utilsService.addDotsToNumber(record.inail) }}&euro;</div>
              <div class="col-md-3 pb-1">
                <strong>{{ "TOTAL_MONTH" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.total_cost) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "SALARY_MONTH_12" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.net_salary) }}&euro;
              </div>
              <div class="col-md-3 pb-1">
                <strong>{{ "ORDINARY_SALARY" | translate }}</strong
                >: {{ _utilsService.addDotsToNumber(record.ordinary_salary) }}&euro;
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body" *ngIf="!costsList || costsList.length < 1">
        <div class="row mt-1">
          <div class="col-12">{{ "NO_DATA_TO_DISPLAY" | translate }}</div>
        </div>
      </div>
    </section>
  </div>
</div>
